import React, { useState, useEffect } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { showDate, toISODate } from '@libs/NwMoment';
import { enumerateDaysBetweenDates } from '@libs/NwUtils';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DateModels = styled.div`
    padding: 16px 30px 16px 40px;
    flex: 1;
    font-size: 0.95rem;
    border-bottom: ${(props) => props.theme.DefaultBorder};

    .date {
        font-weight: 700;
        font-size: 1.3rem;
        text-transform: uppercase;
    }

    svg {
        font-size: 1rem;
        margin-right: 0.5rem;
    }
`;

const RoomLodgingModels = ({ accommodationData }) => {
    const [daysAccommodations, setDaysAccommodations] = useState({});

    useEffect(() => {
        const getAccommodations = async () => {
            const accommodations = await Axios.post('/accommodation/availabilitysearch', {
                FromDate: accommodationData.FromDate,
                ToDate: accommodationData.ToDate,
                RoomID: accommodationData.RoomID,
                RoomsOnly: true,
            });
            const days = enumerateDaysBetweenDates(accommodationData.FromDate, accommodationData.ToDate);
            let daysAccommodations = {};
            days.map((day) => {
                const dayAccommodations = accommodations.filter(
                    (accommodation) =>
                        toISODate(day) >= toISODate(accommodation.FromDate) &&
                        toISODate(day) <= toISODate(accommodation.ToDate)
                );
                const dayModels = dayAccommodations
                    .map((accommodation) => getContactName(accommodation.ModelID))
                    .join(', ');
                daysAccommodations = {
                    ...daysAccommodations,
                    [showDate(day, 'ext-short')]: dayModels,
                };
                return null;
            });
            setDaysAccommodations(daysAccommodations);
        };

        if (accommodationData.RoomID) {
            getAccommodations();
        }
    }, [accommodationData]);

    return (
        <>
            {Object.keys(daysAccommodations).map((day) => {
                return (
                    <DateModels key={day}>
                        <div className="date">{day}</div>
                        <FlexContainer>
                            <NwIcon icon={byPrefixAndName.fasl['users']} />
                            {daysAccommodations[day]}
                        </FlexContainer>
                    </DateModels>
                );
            })}
        </>
    );
};

export default RoomLodgingModels;
